"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EditNoteController = /** @class */ (function () {
    function EditNoteController($stateParams, student, note, $sce, FlashService, VueStoreFactory, $state, $q) {
        this.$stateParams = $stateParams;
        this.student = student;
        this.note = note;
        this.notifications = [];
        this.submitting = false;
        this.$sce = $sce;
        this.$state = $state;
        this.$q = $q;
        this.FlashService = FlashService;
        this.VueStoreFactory = VueStoreFactory;
        this.formatNoteContent = this.formatNoteContent.bind(this);
        this.handleEditNoteChange = this.handleEditNoteChange.bind(this);
        this.submit = this.submit.bind(this);
    }
    EditNoteController.prototype.handleEditNoteChange = function (data) {
        this.note.content = data.html;
    };
    EditNoteController.prototype.formatNoteContent = function (html) {
        return this.$sce.trustAsHtml(html);
    };
    EditNoteController.prototype.submit = function () {
        var _this = this;
        this.submitting = true;
        this.$q
            .when(this.VueStoreFactory.dispatch("studentNotes/UPDATE_STUDENT_NOTE", {
            studentId: this.student.id,
            noteId: this.note.id,
            note: this.note,
        }))
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            // Back to the list, which now reflects the edit -- staying here left
            // both notes lists showing the old content until a refresh.
            _this.$state.go("drivecoach.admin.students.view.notes", {
                userId: _this.student.id,
            });
        })
            .finally(function () {
            _this.submitting = false;
        });
    };
    return EditNoteController;
}());
EditNoteController.$inject = [
    "$stateParams",
    "student",
    "note",
    "$sce",
    "FlashService",
    "VueStoreFactory",
    "$state",
    "$q",
];
exports.default = EditNoteController;
